import React from "react";

import { Navigate, Route, Routes } from "react-router-dom";

import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { selectFeatureOrganizationsEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import { selectProjectBuildResourcesEnabled } from "Reducers/project/capabilities";
import {
  gitProjectSelector,
  selectProjectHasIntegrations
} from "Reducers/project/project";
import useOrganizationFromURL from "src/organization/pages/settings/pages/members/hooks/useOrganizationFromURL";
import { useAppSelector } from "Store/hooks";

import Access from "./access/Routes";
import BackupSchedulesNavigator from "./BackupSchedules/BackupSchedulesNavigator";
import BuildResources from "./BuildResources";
import Certificates from "./certificates/Page";
import DeployKey from "./deployKey/Page";
import Domains from "./domains/Routes";
import GeneralSettings from "./GeneralSettings";
import Integrations from "./integrations/Routes";
import Page from "./Page";
import Variables from "./variables/Routes";

const ProjectSettingsRoutes = () => {
  const organization = useOrganizationFromURL();
  const organizationEnabled = useAppSelector(selectFeatureOrganizationsEnabled);
  const hasIntegrations = useSelectorWithUrlParams(
    selectProjectHasIntegrations
  );
  const project = useSelectorWithUrlParams(gitProjectSelector);
  const showAccessScreens =
    project?.hasLink("#access") ||
    !!organization?.hasLink("members") ||
    !organizationEnabled;

  const areBuildResourcesEnabled = useSelectorWithUrlParams(
    selectProjectBuildResourcesEnabled
  );

  // Do not load the settings page if the project or organization is not loaded
  // this avoids redirects and errors
  if (!project || (organizationEnabled && !organization)) return null;

  return (
    <Page>
      <Routes>
        <Route
          path="access/*"
          element={showAccessScreens ? <Access /> : <Navigate to=".." />}
        />
        <Route path="certificates/*" element={<Certificates />} />
        <Route path="domains/*" element={<Domains />} />
        <Route path="deploykey" element={<DeployKey />} />
        <Route
          path="integrations/*"
          element={hasIntegrations && <Integrations />}
        />
        <Route path="variables/*" element={<Variables />} />
        {areBuildResourcesEnabled && (
          <Route path="resources" element={<BuildResources />} />
        )}

        <Route path="backup-schedules" element={<BackupSchedulesNavigator />} />
        <Route exact path="" element={<GeneralSettings />} />
      </Routes>
    </Page>
  );
};

export default ProjectSettingsRoutes;
